import { render, staticRenderFns } from "./DaifaGuide.vue?vue&type=template&id=b9acc780&scoped=true&"
import script from "./DaifaGuide.vue?vue&type=script&lang=js&"
export * from "./DaifaGuide.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/daifaguide.css?vue&type=style&index=0&id=b9acc780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9acc780",
  null
  
)

export default component.exports